export const DEFAULT_VIEWPORT_META = 'width=device-width,initial-scale=1';
